// extracted by mini-css-extract-plugin
export default {"ctr":"Socket_ctr__iOKgF"};